import React from "react";
import { useNavigate } from "react-router-dom";

const MerchantBusiness = ({ profileData }) => {

  console.log(profileData,"businessDetail");  
  return (
    <div className="pt-8">
      <form
        className="space-y-4 md:space-y-6"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
          {[
            {
              name: "shopName",
              type: "text",
              label: "Shop Name",
              placeholder: "Shop Name",
            },
            {
              name: "category",
              type: "text",
              label: "Category",
              placeholder: "Category",
            },
            {
              name: "brandName",
              type: "text",
              label: "Brand Name",
              placeholder: "Brand Name",
            },
            {
              name: "gstNumber",
              type: "text",
              label: "GST Number",
              placeholder: "GST Number",
            },
            {
              name: "business_email",
              type: "email",
              label: "Business Email",
              placeholder: "Business Email",
            },
            {
              name: "business_mobileNo",
              type: "tel",
              label: "Phone Number",
              placeholder: "Phone Number",
            },
            {
              name: "businessAddress",
              type: "text",
              label: "Business Address",
              placeholder: "Business Address",
            },
            {
              name: "businessPinCode",
              type: "tel",
              label: "Business PinCode",
              placeholder: "Business PinCode",
            },
            {
              name: "businessCity",
              type: "text",
              label: "Business City",
              placeholder: "Business City",
            },
            {
              name: "businessState",
              type: "text",
              label: "Business State",
              placeholder: "Business State",
            },
          ].map((field) => (
            <div key={field.name}>
              <label
                htmlFor={field.name}
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800"
              >
                {field.label}
              </label>
              <input
                type={field.type}
                name={field.name}
                id={field.name}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:outline-none dark:placeholder-gray-400 dark:text-gray-800"
                placeholder={field.placeholder}
                value={profileData?.businessDetils?.[field.name] || "N/A"}
                readOnly
              />
            </div>
          ))}
        </div>
      </form>
    </div>
  );
};

export default MerchantBusiness;
